import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch} from 'react-redux';
import {
  Container,
  Row,
  Col,
	Badge,
  Button
} from 'react-bootstrap';
import Footer from 'Components/Footer';

import ReactApexChart from 'react-apexcharts';
import { DatePicker } from 'antd';
import moment from 'moment';

// load api
import { LoadDashboard, LoadDashboardAppointment } from 'actions/dashboard';

// image
import CALENDAR from 'assets/icon/Calendar.png';
import BACK from 'assets/icon/back.png';
import DREFRESH from 'assets/icon/d-refresh.png';
import DSEARCH from 'assets/icon/d-search.png';
import BRANCHMANAGE from 'assets/icon/branch-manage.png';

export default function NewMainDashboard() {

	const { RangePicker } = DatePicker;

	const [Search, setSearch] = useState({
    date: [
      moment().startOf('month'),
      moment().endOf('month')
    ],
  })

	const buttonRef = useRef(null);
	const [Data, setData] = useState(null);

	const [brand, setBrand] = useState([]);
	const [brandCount, setBrandCount] = useState([]);

	const [series, setSeries] = useState([]);
	const [seriesCount, setSeriesCount] = useState([]);

	const stateBrand = {
	
		series: [{
			name: 'จำนวน',
			data: brandCount,
		}],
		options: {
			chart: {
				type: 'bar',
				height: 250
			},
			plotOptions: {
				bar: {
					borderRadius: 4,
					horizontal: true,
				}
			},
			colors: '#6A3093',
			dataLabels: {
				enabled: false
			},
			xaxis: {
				categories: brand,
			}
		},
	
	};

	const stateSeries = {
	
		series: [{
			name: 'จำนวน',
			data: seriesCount,
		}],
		options: {
			chart: {
				type: 'bar',
				height: 250
			},
			plotOptions: {
				bar: {
					borderRadius: 4,
					horizontal: true,
				}
			},
			colors: '#6A3093',
			dataLabels: {
				enabled: false
			},
			xaxis: {
				categories: series,
			}
		},
	
	};

	const history = useHistory();
  const dispatch = useDispatch();
	const [isLoading, setLoading] = useState(false)

	function closePackage() {
    let path = `/`;
    history.push(path);
  }

	async function getDashboardWhenChange(date){
    setSearch({...Search, date: date});
    setLoading(true)
    const params = {
      start_date: moment(date[0]).format('YYYY-MM-DD'),
      end_date: moment(date[1]).format('YYYY-MM-DD'),
			load_type: 'middle'
    }
    dispatch(LoadDashboard(params)).then( response => {
			setData(response.data.data);

			let cbrand = [];
			let countBrand = [];
			Data?.car_brand_popular.map((item) => {
				cbrand.push(item.brand);
				countBrand.push(item.total);
			});
			setBrand(cbrand);
			setBrandCount(countBrand);
	
	
			let cseries = [];
			let countSeries = [];
			Data?.car_serie_popular.map((item) => {
				cseries.push(item.serie);
				countSeries.push(item.total);
			});
			setSeries(cseries);
			setSeriesCount(countSeries);

			setLoading(false)
    }).catch(e => {
			setLoading(false)
    })
  }

	const refreshDashboard = () => {
    setLoading(true)
    getDashboardWhenChange(Search.date)
  }

  useEffect(() => {
		let getDate = [
			moment().startOf('month'),
      moment().endOf('month')
		];
    getDashboardWhenChange(getDate)

		setTimeout(() => {
      buttonRef.current.click();
    }, 1500);
    setTimeout(() => {
      buttonRef.current.click();
    }, 2000);
		// setLoading(true)
  }, []);

  return (
		<>
		<Container
			fluid
			className="package-container Service Management Dashboard"
		>
			<div className="package">
				<div className="modal-dialog modal-xl" role="document">
					<div className="modal-content">
						<div id="overlay" className={ isLoading ? 'd-block' : ''}>
							<div className='spinner-field-fixed'>
								<div className='spinner-border' role='status'></div>
							</div>
						</div>
						<div className="modal-header">
							<h5 className="modal-title" id="exampleModalLabel">
								<img className="logo pr-2" src={BRANCHMANAGE} />
								การจัดการสาขา &gt; ดู
							</h5>
							<button
								type="button"
								className="btn-close"
								data-dismiss="modal"
								aria-label="Close"
								onClick={closePackage}
							>
								<span aria-hidden="true">X</span>
							</button>
						</div>
						<div className="modal-header-mobile">
							<button
								type="button"
								className="btn-close"
								data-dismiss="modal"
								aria-label="Close"
								onClick={closePackage}
							>
								<img src={BACK} />
							</button>
							<h5 className="modal-title" id="exampleModalLabel">
								<img className="logo pr-2" src={BRANCHMANAGE} />
								การจัดการสาขา &gt; ดู
							</h5>
						</div>
						<div className="modal-body ">

							{/* //TODO: Body Content */}
							
									{/* //*Dasboard Session */}
									<div class="dash-content text-left pb-4">
										<Row>
											<Col xs={12} md={6}><h2 className='dash-main-text'>Dashboard</h2></Col>
											<Col xs={12} md={6}>
												<div className='ml-auto mr-0'>
													<RangePicker
														ranges={{
															Today: [moment(), moment()],
															'This Month': [
																moment().startOf('month'),
																moment().endOf('month'),
															],
														}}
														value={Search.date}
														onChange={(date) => {
															getDashboardWhenChange(date);
														}}
														suffixIcon={<img src={CALENDAR} />}
														separator="-"
														className="calendar-antd-dashboard"
														style={{
															borderRadius: '20px',
															boxShadow: 'none ',
															height: '50px',
														}}
													/>
													<Button
														ref={buttonRef}
														className="ml-3"
														style={{ boxshadown: 'none', borderRadius: '50%' }}
														onClick={ () => refreshDashboard() }
													>
														<img src={DREFRESH} width={'36px'} />
													</Button>
												</div>
											</Col>
										</Row>
										<Row style={{ paddingLeft: '15px',marginTop: '15px' }}>
											<Col xs={12} className='dash-content dash-gradient dash-shadow'>
												<div className='text-right'>
													{
														Data?.total_percent >= 100 ?
															<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginTop: '-6px' }}>
																<path d="M6.69999 14.7473L6.87925 2.08064M6.87925 2.08064L1.09859 7.69997M6.87925 2.08064L12.4986 7.8613" stroke="#0FA958" stroke-width="2"/>
															</svg>
														: 
															<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginTop: '0px' }}>
																<path d="M6.77022 0.0314528L6.70042 12.6992M6.70042 12.6992L12.4323 7.03012M6.70042 12.6992L1.03135 6.96729" stroke="#FF0000" stroke-width="2"/>
															</svg>
													}
													<font style={{ opacity: '70%',marginLeft: '3px' }}>{ Data?.total_percent }%</font>
												</div>
												<Row style={{paddingLeft: '15px',paddingRight: '15px'}}>
													<Col xs={12} md={4}><h2 className='text-light mb-0'>รายได้</h2></Col>
													<Col xs={12} md={8}><h2 className='text-light mb-0'>{ Data?.all_income } บาท</h2></Col>
												</Row>
											</Col>
										</Row>
										<Row style={{ paddingLeft: '15px',marginTop: '15px' }}>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '10px' }} className='dash-content dash-shadow'>
													<div className='d-flex'>
														<div><h5 className='mb-1'>สาขาสวนดอก</h5></div>
														<div className='mr-0 ml-auto'>
															{
																Data?.branch[0].percent >= 100 ?
																	<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginTop: '-6px' }}>
																		<path d="M6.69999 14.7473L6.87925 2.08064M6.87925 2.08064L1.09859 7.69997M6.87925 2.08064L12.4986 7.8613" stroke="#0FA958" stroke-width="2"/>
																	</svg>
																: 
																	<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginTop: '0px' }}>
																		<path d="M6.77022 0.0314528L6.70042 12.6992M6.70042 12.6992L12.4323 7.03012M6.70042 12.6992L1.03135 6.96729" stroke="#FF0000" stroke-width="2"/>
																	</svg>
															}
															<font style={{ opacity: '70%',marginLeft: '3px' }}>{ Data?.branch[0].percent }%</font>
														</div>
													</div>
													<h2 className='dash-main-text font-weight-bold mb-0'>{ Data?.branch[0].total_income }</h2>
													<p className='text-muted mb-0' style={{ fontSize: '16px' }}>ยอดบรรลุหนทางสว่าง</p>
													<span className='text-muted' style={{ fontSize: '16px' }}>({ Data?.branch[0].net })</span>
												</div>
											</Col>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '10px',backgroundColor: 'rgba(207, 140, 255, 0.2)' }} className='dash-content dash-shadow'>
													<div className='d-flex'>
														<div><h5 className='mb-1'>สาขาอาเขต</h5></div>
														<div className='mr-0 ml-auto'>
															{
																Data?.branch[1].percent >= 100 ?
																	<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginTop: '-6px' }}>
																		<path d="M6.69999 14.7473L6.87925 2.08064M6.87925 2.08064L1.09859 7.69997M6.87925 2.08064L12.4986 7.8613" stroke="#0FA958" stroke-width="2"/>
																	</svg>
																: 
																	<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginTop: '0px' }}>
																		<path d="M6.77022 0.0314528L6.70042 12.6992M6.70042 12.6992L12.4323 7.03012M6.70042 12.6992L1.03135 6.96729" stroke="#FF0000" stroke-width="2"/>
																	</svg>
															}
															<font style={{ opacity: '70%',marginLeft: '3px' }}>{ Data?.branch[1].percent }%</font>
														</div>
													</div>
													<h2 className='dash-main-text font-weight-bold mb-0'>{ Data?.branch[1].total_income }</h2>
													<p className='text-muted mb-0' style={{ fontSize: '16px' }}>ยอดบรรลุหนทางสว่าง</p>
													<span className='text-muted' style={{ fontSize: '16px' }}>({ Data?.branch[1].net })</span>
												</div>
											</Col>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '10px',backgroundColor: 'rgba(169, 146, 227, 0.45)' }} className='dash-content dash-shadow'>
													<div className='d-flex'>
														<div><h5 className='mb-1'>สาขาสันทราย</h5></div>
														<div className='mr-0 ml-auto'>
															{
																Data?.branch[2].percent >= 100 ?
																	<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginTop: '-6px' }}>
																		<path d="M6.69999 14.7473L6.87925 2.08064M6.87925 2.08064L1.09859 7.69997M6.87925 2.08064L12.4986 7.8613" stroke="#0FA958" stroke-width="2"/>
																	</svg>
																: 
																	<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginTop: '0px' }}>
																		<path d="M6.77022 0.0314528L6.70042 12.6992M6.70042 12.6992L12.4323 7.03012M6.70042 12.6992L1.03135 6.96729" stroke="#FF0000" stroke-width="2"/>
																	</svg>
															}
															<font style={{ opacity: '70%',marginLeft: '3px' }}>{ Data?.branch[2].percent }%</font>
														</div>
													</div>
													<h2 className='dash-main-text font-weight-bold mb-0'>{ Data?.branch[2].total_income }</h2>
													<p className='text-muted mb-0' style={{ fontSize: '16px' }}>ยอดบรรลุหนทางสว่าง</p>
													<span className='text-muted' style={{ fontSize: '16px' }}>({ Data?.branch[2].net })</span>
												</div>
											</Col>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '10px',backgroundColor: 'rgba(169, 146, 227, 0.65)' }} className='dash-content dash-shadow'>
													<div className='d-flex'>
														<div><h5 className='mb-1'>สาขา Relyne</h5></div>
														<div className='mr-0 ml-auto'>
															{
																Data?.branch[3].percent >= 100 ?
																	<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginTop: '-6px' }}>
																		<path d="M6.69999 14.7473L6.87925 2.08064M6.87925 2.08064L1.09859 7.69997M6.87925 2.08064L12.4986 7.8613" stroke="#0FA958" stroke-width="2"/>
																	</svg>
																: 
																	<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginTop: '0px' }}>
																		<path d="M6.77022 0.0314528L6.70042 12.6992M6.70042 12.6992L12.4323 7.03012M6.70042 12.6992L1.03135 6.96729" stroke="#FF0000" stroke-width="2"/>
																	</svg>
															}
															<font style={{ opacity: '70%',marginLeft: '3px' }}>{ Data?.branch[3].percent }%</font>
														</div>
													</div>
													<h2 className='dash-main-text font-weight-bold mb-0'>{ Data?.branch[3].total_income }</h2>
													<p className='text-muted mb-0' style={{ fontSize: '16px' }}>ยอดบรรลุหนทางสว่าง</p>
													<span className='text-muted' style={{ fontSize: '16px' }}>({ Data?.branch[3].net })</span>
												</div>
											</Col>
										</Row>
									</div>
									{/* //*End Dasboard Session */}

									{/* //*Performance Session */}
									<div class="dash-content text-left pb-4 mt-4">
										<Row>
											<Col xs={12} md={6}><h2 className='dash-main-text'>Performance</h2></Col>
											<Col xs={12} md={6}>
												<div className='d-flex text-right' style={{ marginTop: '7px' }}>
													<div>
														<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
															<circle cx="7" cy="7" r="7" fill="#C4C4C4"/>
														</svg>
														<font style={{ marginLeft: '3px' }}>สาขาสวนดอก</font>
													</div>
													<div style={{ marginLeft: '18px', marginRight: '18px' }}>
														<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
															<circle cx="7" cy="7" r="7" fill="#ECD1FF"/>
														</svg>
														<font style={{ marginLeft: '3px' }}>สาขาอาเขต</font>
													</div>
													<div style={{ marginRight: '18px' }}>
														<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
															<circle cx="7" cy="7" r="7" fill="#8056EE"/>
														</svg>
														<font style={{ marginLeft: '3px' }}>สาขาสันทราย</font>
													</div>
													<div>
														<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
															<circle cx="7" cy="7" r="7" fill="#5e36c7"/>
														</svg>
														<font style={{ marginLeft: '3px' }}>สาขา Relyne</font>
													</div>
												</div>
											</Col>
										</Row>
										<Row style={{ paddingLeft: '15px',marginTop: '15px' }}>
											<Col xs={12} className='dash-content dash-shadow'>
												<Row style={{paddingLeft: '15px',paddingRight: '15px'}}>
													<Col xs={12} md={4}>
														<svg width="41.4" height="29.4" viewBox="0 0 69 49" fill="none" xmlns="http://www.w3.org/2000/svg">
															<path d="M45.9996 24.5C43.0441 24.5 40.1864 23.2221 37.9496 20.9029C35.7747 18.6409 34.4465 15.6243 34.2122 12.4115C33.962 8.98425 35.0416 5.83266 37.251 3.53579C39.4604 1.23892 42.5496 0 45.9996 0C49.4251 0 52.5229 1.26119 54.7252 3.5525C56.949 5.86607 58.0314 9.01209 57.7813 12.4101C57.5412 15.6271 56.2144 18.6423 54.0438 20.9015C51.8128 23.2221 48.9565 24.5 45.9996 24.5ZM64.9501 48.9999H27.0506C26.4412 49.0031 25.8393 48.8708 25.291 48.6133C24.7427 48.3558 24.2628 47.98 23.8881 47.5146C23.4906 47.0102 23.2161 46.4252 23.0852 45.8035C22.9543 45.1818 22.9702 44.5394 23.132 43.9245C24.3423 39.2181 27.3409 35.3148 31.8029 32.6379C35.7632 30.263 40.8045 28.9545 45.9996 28.9545C51.2968 28.9545 56.2058 30.2073 60.1891 32.5808C64.6611 35.2438 67.664 39.1693 68.8687 43.9329C69.0284 44.5482 69.0426 45.1906 68.9102 45.812C68.7778 46.4334 68.5022 47.0178 68.1039 47.5216C67.7296 47.9848 67.2508 48.3588 66.7041 48.6151C66.1574 48.8713 65.5574 49.003 64.9501 48.9999ZM18.831 25.0568C13.7725 25.0568 9.32485 20.502 8.91229 14.9046C8.70817 12.037 9.63104 9.38516 11.4998 7.44047C13.3484 5.51528 15.956 4.45454 18.831 4.45454C21.706 4.45454 24.2935 5.52085 26.1521 7.45718C28.0352 9.41718 28.9552 12.0635 28.7396 14.9074C28.3271 20.5034 23.8809 25.0568 18.831 25.0568ZM28.2696 29.4348C25.741 28.2376 22.4592 27.639 18.8324 27.639C14.5976 27.639 10.4849 28.7081 7.25055 30.6486C3.58351 32.8522 1.11677 36.0609 0.120586 39.935C-0.0251973 40.4922 -0.0389858 41.0741 0.0802518 41.6372C0.199489 42.2004 0.448666 42.7301 0.809145 43.1868C1.15119 43.612 1.58939 43.9556 2.09005 44.1911C2.5907 44.4267 3.14047 44.5479 3.69707 44.5454H19.6532C19.9225 44.5454 20.1833 44.4538 20.39 44.2867C20.5968 44.1195 20.7364 43.8874 20.7845 43.6308C20.8004 43.5431 20.8205 43.4554 20.8435 43.3691C22.0625 38.6278 24.9188 34.6215 29.1392 31.701C29.2945 31.5927 29.4193 31.4485 29.5025 31.2816C29.5857 31.1147 29.6245 30.9304 29.6155 30.7453C29.6065 30.5602 29.55 30.3802 29.451 30.2216C29.352 30.063 29.2137 29.9308 29.0487 29.8371C28.823 29.709 28.5642 29.574 28.2696 29.4348Z" fill="#9747FF"/>
														</svg>
													</Col>
													<Col xs={12} md={8}><h2 className='mb-0'>{ Data?.all_employee } คน</h2></Col>
												</Row>
											</Col>
										</Row>
										<Row style={{ paddingLeft: '10px',marginTop: '15px' }}>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '10px' }} className='dash-content dash-shadow'>
													<h5 className='mb-3'>
														<svg width="22" height="22" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '7px' }}>
															<circle cx="17.5" cy="17.5" r="17.5" fill="#C4C4C4"/>
															<path d="M21.5655 16.4394C20.5207 16.4394 19.5103 15.9692 18.7196 15.1158C17.9507 14.2834 17.4811 13.1735 17.3982 11.9912C17.3098 10.7301 17.6915 9.57047 18.4726 8.7253C19.2537 7.88013 20.3458 7.42426 21.5655 7.42426C22.7766 7.42426 23.8718 7.88833 24.6503 8.73145C25.4365 9.58277 25.8192 10.7404 25.7308 11.9907C25.6459 13.1745 25.1768 14.284 24.4094 15.1153C23.6207 15.9692 22.6109 16.4394 21.5655 16.4394ZM28.2652 25.4545H14.8664C14.651 25.4557 14.4381 25.407 14.2443 25.3123C14.0505 25.2175 13.8808 25.0792 13.7483 24.908C13.6078 24.7224 13.5108 24.5071 13.4645 24.2784C13.4182 24.0496 13.4238 23.8132 13.481 23.587C13.9089 21.8551 14.969 20.4189 16.5465 19.4339C17.9466 18.56 19.7289 18.0785 21.5655 18.0785C23.4383 18.0785 25.1738 18.5395 26.582 19.4129C28.163 20.3927 29.2247 21.8372 29.6505 23.59C29.707 23.8165 29.712 24.0528 29.6652 24.2815C29.6184 24.5101 29.521 24.7252 29.3802 24.9106C29.2478 25.081 29.0786 25.2186 28.8853 25.3129C28.692 25.4072 28.4799 25.4556 28.2652 25.4545ZM11.9605 16.6443C10.1721 16.6443 8.5997 14.9683 8.45385 12.9086C8.38168 11.8535 8.70795 10.8777 9.36862 10.1621C10.0222 9.45369 10.9441 9.06337 11.9605 9.06337C12.9769 9.06337 13.8916 9.45574 14.5487 10.1682C15.2145 10.8895 15.5397 11.8632 15.4635 12.9097C15.3177 14.9688 13.7458 16.6443 11.9605 16.6443ZM15.2973 18.2552C14.4034 17.8147 13.2432 17.5945 11.961 17.5945C10.4638 17.5945 9.00983 17.9879 7.86637 18.7019C6.56994 19.5127 5.69786 20.6934 5.34567 22.1189C5.29413 22.324 5.28926 22.5381 5.33141 22.7453C5.37357 22.9525 5.46166 23.1474 5.5891 23.3155C5.71003 23.472 5.86495 23.5984 6.04194 23.6851C6.21894 23.7717 6.41331 23.8163 6.61008 23.8154H12.2512C12.3464 23.8154 12.4386 23.7817 12.5116 23.7202C12.5847 23.6587 12.6341 23.5733 12.6511 23.4789C12.6567 23.4466 12.6638 23.4143 12.6719 23.3826C13.1029 21.638 14.1127 20.1638 15.6048 19.0891C15.6597 19.0493 15.7038 18.9962 15.7332 18.9348C15.7626 18.8734 15.7764 18.8056 15.7732 18.7375C15.77 18.6693 15.75 18.6031 15.715 18.5448C15.68 18.4864 15.6311 18.4378 15.5728 18.4033C15.493 18.3561 15.4015 18.3065 15.2973 18.2552Z" fill="white"/>
														</svg>
														สาขาสวนดอก
													</h5>
													<div className='d-flex' style={{marginLeft: '29px'}}>
														<div>จำนวน</div>
														<div style={{marginLeft: '15px'}}>
															<h1 className='mb-3 dash-main-text'>
																{ Data?.branch[0].total_employee } คน
															</h1>
														</div>

													</div>
												</div>
											</Col>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '10px' }} className='dash-content dash-shadow'>
													<h5 className='mb-3'>
														<svg width="22" height="22" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '7px' }}>
															<circle cx="17.5" cy="17.5" r="17.5" fill="#ECD1FF"/>
															<path d="M21.5655 16.4394C20.5207 16.4394 19.5103 15.9692 18.7196 15.1158C17.9507 14.2834 17.4811 13.1735 17.3982 11.9912C17.3098 10.7301 17.6915 9.57047 18.4726 8.7253C19.2537 7.88013 20.3458 7.42426 21.5655 7.42426C22.7766 7.42426 23.8718 7.88833 24.6503 8.73145C25.4365 9.58277 25.8192 10.7404 25.7308 11.9907C25.6459 13.1745 25.1768 14.284 24.4094 15.1153C23.6207 15.9692 22.6109 16.4394 21.5655 16.4394ZM28.2652 25.4545H14.8664C14.651 25.4557 14.4381 25.407 14.2443 25.3123C14.0505 25.2175 13.8808 25.0792 13.7483 24.908C13.6078 24.7224 13.5108 24.5071 13.4645 24.2784C13.4182 24.0496 13.4238 23.8132 13.481 23.587C13.9089 21.8551 14.969 20.4189 16.5465 19.4339C17.9466 18.56 19.7289 18.0785 21.5655 18.0785C23.4383 18.0785 25.1738 18.5395 26.582 19.4129C28.163 20.3927 29.2247 21.8372 29.6505 23.59C29.707 23.8165 29.712 24.0528 29.6652 24.2815C29.6184 24.5101 29.521 24.7252 29.3802 24.9106C29.2478 25.081 29.0786 25.2186 28.8853 25.3129C28.692 25.4072 28.4799 25.4556 28.2652 25.4545ZM11.9605 16.6443C10.1721 16.6443 8.5997 14.9683 8.45385 12.9086C8.38168 11.8535 8.70795 10.8777 9.36862 10.1621C10.0222 9.45369 10.9441 9.06337 11.9605 9.06337C12.9769 9.06337 13.8916 9.45574 14.5487 10.1682C15.2145 10.8895 15.5397 11.8632 15.4635 12.9097C15.3177 14.9688 13.7458 16.6443 11.9605 16.6443ZM15.2973 18.2552C14.4034 17.8147 13.2432 17.5945 11.961 17.5945C10.4638 17.5945 9.00983 17.9879 7.86637 18.7019C6.56994 19.5127 5.69786 20.6934 5.34567 22.1189C5.29413 22.324 5.28926 22.5381 5.33141 22.7453C5.37357 22.9525 5.46166 23.1474 5.5891 23.3155C5.71003 23.472 5.86495 23.5984 6.04194 23.6851C6.21894 23.7717 6.41331 23.8163 6.61008 23.8154H12.2512C12.3464 23.8154 12.4386 23.7817 12.5116 23.7202C12.5847 23.6587 12.6341 23.5733 12.6511 23.4789C12.6567 23.4466 12.6638 23.4143 12.6719 23.3826C13.1029 21.638 14.1127 20.1638 15.6048 19.0891C15.6597 19.0493 15.7038 18.9962 15.7332 18.9348C15.7626 18.8734 15.7764 18.8056 15.7732 18.7375C15.77 18.6693 15.75 18.6031 15.715 18.5448C15.68 18.4864 15.6311 18.4378 15.5728 18.4033C15.493 18.3561 15.4015 18.3065 15.2973 18.2552Z" fill="white"/>
														</svg>
														สาขาอาเขต
													</h5>
													<div className='d-flex' style={{marginLeft: '29px'}}>
														<div>จำนวน</div>
														<div style={{marginLeft: '15px'}}>
															<h1 className='mb-3 dash-main-text'>
																{ Data?.branch[1].total_employee } คน
															</h1>
														</div>

													</div>
												</div>
											</Col>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '10px' }} className='dash-content dash-shadow'>
													<h5 className='mb-3'>
														<svg width="22" height="22" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '7px' }}>
															<circle cx="17.5" cy="17.5" r="17.5" fill="#8056EE"/>
															<path d="M21.5655 16.4394C20.5207 16.4394 19.5103 15.9692 18.7196 15.1158C17.9507 14.2834 17.4811 13.1735 17.3982 11.9912C17.3098 10.7301 17.6915 9.57047 18.4726 8.7253C19.2537 7.88013 20.3458 7.42426 21.5655 7.42426C22.7766 7.42426 23.8718 7.88833 24.6503 8.73145C25.4365 9.58277 25.8192 10.7404 25.7308 11.9907C25.6459 13.1745 25.1768 14.284 24.4094 15.1153C23.6207 15.9692 22.6109 16.4394 21.5655 16.4394ZM28.2652 25.4545H14.8664C14.651 25.4557 14.4381 25.407 14.2443 25.3123C14.0505 25.2175 13.8808 25.0792 13.7483 24.908C13.6078 24.7224 13.5108 24.5071 13.4645 24.2784C13.4182 24.0496 13.4238 23.8132 13.481 23.587C13.9089 21.8551 14.969 20.4189 16.5465 19.4339C17.9466 18.56 19.7289 18.0785 21.5655 18.0785C23.4383 18.0785 25.1738 18.5395 26.582 19.4129C28.163 20.3927 29.2247 21.8372 29.6505 23.59C29.707 23.8165 29.712 24.0528 29.6652 24.2815C29.6184 24.5101 29.521 24.7252 29.3802 24.9106C29.2478 25.081 29.0786 25.2186 28.8853 25.3129C28.692 25.4072 28.4799 25.4556 28.2652 25.4545ZM11.9605 16.6443C10.1721 16.6443 8.5997 14.9683 8.45385 12.9086C8.38168 11.8535 8.70795 10.8777 9.36862 10.1621C10.0222 9.45369 10.9441 9.06337 11.9605 9.06337C12.9769 9.06337 13.8916 9.45574 14.5487 10.1682C15.2145 10.8895 15.5397 11.8632 15.4635 12.9097C15.3177 14.9688 13.7458 16.6443 11.9605 16.6443ZM15.2973 18.2552C14.4034 17.8147 13.2432 17.5945 11.961 17.5945C10.4638 17.5945 9.00983 17.9879 7.86637 18.7019C6.56994 19.5127 5.69786 20.6934 5.34567 22.1189C5.29413 22.324 5.28926 22.5381 5.33141 22.7453C5.37357 22.9525 5.46166 23.1474 5.5891 23.3155C5.71003 23.472 5.86495 23.5984 6.04194 23.6851C6.21894 23.7717 6.41331 23.8163 6.61008 23.8154H12.2512C12.3464 23.8154 12.4386 23.7817 12.5116 23.7202C12.5847 23.6587 12.6341 23.5733 12.6511 23.4789C12.6567 23.4466 12.6638 23.4143 12.6719 23.3826C13.1029 21.638 14.1127 20.1638 15.6048 19.0891C15.6597 19.0493 15.7038 18.9962 15.7332 18.9348C15.7626 18.8734 15.7764 18.8056 15.7732 18.7375C15.77 18.6693 15.75 18.6031 15.715 18.5448C15.68 18.4864 15.6311 18.4378 15.5728 18.4033C15.493 18.3561 15.4015 18.3065 15.2973 18.2552Z" fill="white"/>
														</svg>
														สาขาสันทราย
													</h5>
													<div className='d-flex' style={{marginLeft: '29px'}}>
														<div>จำนวน</div>
														<div style={{marginLeft: '15px'}}>
															<h1 className='mb-3 dash-main-text'>
																{ Data?.branch[2].total_employee } คน
															</h1>
														</div>

													</div>
												</div>
											</Col>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '10px' }} className='dash-content dash-shadow'>
													<h5 className='mb-3'>
														<svg width="22" height="22" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '7px' }}>
															<circle cx="17.5" cy="17.5" r="17.5" fill="#5e36c"/>
															<path d="M21.5655 16.4394C20.5207 16.4394 19.5103 15.9692 18.7196 15.1158C17.9507 14.2834 17.4811 13.1735 17.3982 11.9912C17.3098 10.7301 17.6915 9.57047 18.4726 8.7253C19.2537 7.88013 20.3458 7.42426 21.5655 7.42426C22.7766 7.42426 23.8718 7.88833 24.6503 8.73145C25.4365 9.58277 25.8192 10.7404 25.7308 11.9907C25.6459 13.1745 25.1768 14.284 24.4094 15.1153C23.6207 15.9692 22.6109 16.4394 21.5655 16.4394ZM28.2652 25.4545H14.8664C14.651 25.4557 14.4381 25.407 14.2443 25.3123C14.0505 25.2175 13.8808 25.0792 13.7483 24.908C13.6078 24.7224 13.5108 24.5071 13.4645 24.2784C13.4182 24.0496 13.4238 23.8132 13.481 23.587C13.9089 21.8551 14.969 20.4189 16.5465 19.4339C17.9466 18.56 19.7289 18.0785 21.5655 18.0785C23.4383 18.0785 25.1738 18.5395 26.582 19.4129C28.163 20.3927 29.2247 21.8372 29.6505 23.59C29.707 23.8165 29.712 24.0528 29.6652 24.2815C29.6184 24.5101 29.521 24.7252 29.3802 24.9106C29.2478 25.081 29.0786 25.2186 28.8853 25.3129C28.692 25.4072 28.4799 25.4556 28.2652 25.4545ZM11.9605 16.6443C10.1721 16.6443 8.5997 14.9683 8.45385 12.9086C8.38168 11.8535 8.70795 10.8777 9.36862 10.1621C10.0222 9.45369 10.9441 9.06337 11.9605 9.06337C12.9769 9.06337 13.8916 9.45574 14.5487 10.1682C15.2145 10.8895 15.5397 11.8632 15.4635 12.9097C15.3177 14.9688 13.7458 16.6443 11.9605 16.6443ZM15.2973 18.2552C14.4034 17.8147 13.2432 17.5945 11.961 17.5945C10.4638 17.5945 9.00983 17.9879 7.86637 18.7019C6.56994 19.5127 5.69786 20.6934 5.34567 22.1189C5.29413 22.324 5.28926 22.5381 5.33141 22.7453C5.37357 22.9525 5.46166 23.1474 5.5891 23.3155C5.71003 23.472 5.86495 23.5984 6.04194 23.6851C6.21894 23.7717 6.41331 23.8163 6.61008 23.8154H12.2512C12.3464 23.8154 12.4386 23.7817 12.5116 23.7202C12.5847 23.6587 12.6341 23.5733 12.6511 23.4789C12.6567 23.4466 12.6638 23.4143 12.6719 23.3826C13.1029 21.638 14.1127 20.1638 15.6048 19.0891C15.6597 19.0493 15.7038 18.9962 15.7332 18.9348C15.7626 18.8734 15.7764 18.8056 15.7732 18.7375C15.77 18.6693 15.75 18.6031 15.715 18.5448C15.68 18.4864 15.6311 18.4378 15.5728 18.4033C15.493 18.3561 15.4015 18.3065 15.2973 18.2552Z" fill="white"/>
														</svg>
														สาขา Relyne
													</h5>
													<div className='d-flex' style={{marginLeft: '29px'}}>
														<div>จำนวน</div>
														<div style={{marginLeft: '15px'}}>
															<h1 className='mb-3 dash-main-text'>
																{ Data?.branch[3].total_employee } คน
															</h1>
														</div>

													</div>
												</div>
											</Col>
										</Row>
										<Row style={{ paddingLeft: '10px',marginTop: '10px' }}>

											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '15px' }} className='dash-content dash-shadow'>
													<div className='d-flex mt-2'>
														<div><h5 className='mb-1 dash-main-text'>{ Data?.branch[0].job_per_employee }</h5></div>
														<div className='mr-0 ml-auto'>
															<font style={{marginLeft: '3px' }}>Job/People</font>
														</div>
													</div>
													<div className='d-flex mt-2'>
														<div><h5 className='mb-1 dash-main-text'>{ Data?.branch[0].employee_per_job }</h5></div>
														<div className='mr-0 ml-auto'>
															<font style={{marginLeft: '3px' }}>คน/Job</font>
														</div>
													</div>

													<div className='d-flex mt-3'>
														<div><h3 className='mb-1 dash-main-text'>{ Data?.branch[0].income_per_day_employee }.-</h3></div>
														<div className='mr-0 ml-auto pt-1'>
															<font style={{marginLeft: '3px' }}>/People/Day</font>
														</div>
													</div>
												</div>
											</Col>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '15px' }} className='dash-content dash-shadow'>
													<div className='d-flex mt-2'>
														<div><h5 className='mb-1 dash-main-text'>{ Data?.branch[1].job_per_employee }</h5></div>
														<div className='mr-0 ml-auto'>
															<font style={{marginLeft: '3px' }}>Job/People</font>
														</div>
													</div>
													<div className='d-flex mt-2'>
														<div><h5 className='mb-1 dash-main-text'>{ Data?.branch[1].employee_per_job }</h5></div>
														<div className='mr-0 ml-auto'>
															<font style={{marginLeft: '3px' }}>คน/Job</font>
														</div>
													</div>

													<div className='d-flex mt-3'>
														<div><h3 className='mb-1 dash-main-text'>{ Data?.branch[1].income_per_day_employee }.-</h3></div>
														<div className='mr-0 ml-auto pt-1'>
															<font style={{marginLeft: '3px' }}>/People/Day</font>
														</div>
													</div>
												</div>
											</Col>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '15px' }} className='dash-content dash-shadow'>
													<div className='d-flex mt-2'>
														<div><h5 className='mb-1 dash-main-text'>{ Data?.branch[2].job_per_employee }</h5></div>
														<div className='mr-0 ml-auto'>
															<font style={{marginLeft: '3px' }}>Job/People</font>
														</div>
													</div>
													<div className='d-flex mt-2'>
														<div><h5 className='mb-1 dash-main-text'>{ Data?.branch[2].employee_per_job }</h5></div>
														<div className='mr-0 ml-auto'>
															<font style={{marginLeft: '3px' }}>คน/Job</font>
														</div>
													</div>

													<div className='d-flex mt-3'>
														<div><h3 className='mb-1 dash-main-text'>{ Data?.branch[2].income_per_day_employee }.-</h3></div>
														<div className='mr-0 ml-auto pt-1'>
															<font style={{marginLeft: '3px' }}>/People/Day</font>
														</div>
													</div>
												</div>
											</Col>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '15px' }} className='dash-content dash-shadow'>
													<div className='d-flex mt-2'>
														<div><h5 className='mb-1 dash-main-text'>{ Data?.branch[3].job_per_employee }</h5></div>
														<div className='mr-0 ml-auto'>
															<font style={{marginLeft: '3px' }}>Job/People</font>
														</div>
													</div>
													<div className='d-flex mt-2'>
														<div><h5 className='mb-1 dash-main-text'>{ Data?.branch[3].employee_per_job }</h5></div>
														<div className='mr-0 ml-auto'>
															<font style={{marginLeft: '3px' }}>คน/Job</font>
														</div>
													</div>

													<div className='d-flex mt-3'>
														<div><h3 className='mb-1 dash-main-text'>{ Data?.branch[3].income_per_day_employee }.-</h3></div>
														<div className='mr-0 ml-auto pt-1'>
															<font style={{marginLeft: '3px' }}>/People/Day</font>
														</div>
													</div>
												</div>
											</Col>

										</Row>
										<h5 className='mt-4 pl-1'>Top Spend By Cars</h5>
										<Row style={{ paddingLeft: '10px',marginTop: '15px' }}>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '10px' }} className='dash-content dash-shadow'>
													<div className='mb-2 d-flex'>
														<svg width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
															<circle cx="7" cy="7" r="7" fill="#C4C4C4"/>
														</svg> <h5 className='mb-1 ml-2'>สาขาสวนดอก</h5>
													</div>

													<div className='mb-2'>
														{
															Data?.branch[0].spend_car.map( (item, key) => {
																return (
																	<div className='d-flex border-top border-1 pt-1'>
																		<div>{ key + 1 }</div>
																		<div className='mr-auto ml-3 dash-main-text'><b>{ item.total }</b></div>
																		<div className='mr-0 ml-auto'>{ item.brand }</div>
																	</div>
																)
															})
														}
													</div>

												</div>
											</Col>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '10px' }} className='dash-content dash-shadow'>
													<div className=' d-flex mb-2'>
														<svg width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
															<circle cx="7" cy="7" r="7" fill="#ECD1FF"/>
														</svg> <h5 className='mb-1 ml-2'>สาขาอาเขต</h5>
													</div>

													<div className='mb-2'>
														{
															Data?.branch[1].spend_car.map( (item, key) => {
																return (
																	<div className='d-flex border-top border-1 pt-1'>
																		<div>{ key + 1 }</div>
																		<div className='mr-auto ml-3 dash-main-text'><b>{ item.total }</b></div>
																		<div className='mr-0 ml-auto'>{ item.brand }</div>
																	</div>
																)
															})
														}
													</div>

												</div>
											</Col>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '10px' }} className='dash-content dash-shadow'>
													<div className=' d-flex mb-2'>
														<svg width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
															<circle cx="7" cy="7" r="7" fill="#8056EE"/>
														</svg> <h5 className='mb-1 ml-2'>สาขาสันทราย</h5>
													</div>

													<div className='mb-2'>
														{
															Data?.branch[2].spend_car.map( (item, key) => {
																return (
																	<div className='d-flex border-top border-1 pt-1'>
																		<div>{ key + 1 }</div>
																		<div className='mr-auto ml-3 dash-main-text'><b>{ item.total }</b></div>
																		<div className='mr-0 ml-auto'>{ item.brand }</div>
																	</div>
																)
															})
														}
													</div>

												</div>
											</Col>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '10px' }} className='dash-content dash-shadow'>
													<div className=' d-flex mb-2'>
														<svg width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
															<circle cx="7" cy="7" r="7" fill="#5E36C7"/>
														</svg> <h5 className='mb-1 ml-2'>สาขา Relyne</h5>
													</div>

													<div className='mb-2'>
														{
															Data?.branch[3].spend_car.map( (item, key) => {
																return (
																	<div className='d-flex border-top border-1 pt-1'>
																		<div>{ key + 1 }</div>
																		<div className='mr-auto ml-3 dash-main-text'><b>{ item.total }</b></div>
																		<div className='mr-0 ml-auto'>{ item.brand }</div>
																	</div>
																)
															})
														}
													</div>

												</div>
											</Col>
										</Row>
										<h5 className='mt-4 pl-1'>Top Spends By Customer</h5>
										<Row style={{ paddingLeft: '10px',marginTop: '15px' }}>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '10px' }} className='dash-content dash-shadow'>
													<div className='d-flex mb-2'>
														<svg width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
															<circle cx="7" cy="7" r="7" fill="#C4C4C4"/>
														</svg> <h5 className='mb-1 ml-2'>สาขาสวนดอก</h5>
													</div>

													<div className='mb-2'>
														{
															Data?.branch[0].spend_customer.map( (item, key) => {
																return (
																	<div className='d-flex border-top border-1 pt-1'>
																		<div>{ key + 1 }</div>
																		<div className='mr-auto ml-3 dash-main-text'><b>{ item.total }</b></div>
																		<div className='mr-0 ml-auto'>{ item.name }</div>
																	</div>
																)
															})
														}
													</div>

												</div>
											</Col>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '10px' }} className='dash-content dash-shadow'>
													<div className='d-flex mb-2'>
														<svg width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
															<circle cx="7" cy="7" r="7" fill="#ECD1FF"/>
														</svg> <h5 className='mb-1 ml-2'>สาขาอาเขต</h5>
													</div>

													<div className='mb-2'>
														{
															Data?.branch[1].spend_customer.map( (item, key) => {
																return (
																	<div className='d-flex border-top border-1 pt-1'>
																		<div>{ key + 1 }</div>
																		<div className='mr-auto ml-3 dash-main-text'><b>{ item.total }</b></div>
																		<div className='mr-0 ml-auto'>{ item.name }</div>
																	</div>
																)
															})
														}
													</div>

												</div>
											</Col>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '10px' }} className='dash-content dash-shadow'>
													<div className='d-flex mb-2'>
														<svg width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
															<circle cx="7" cy="7" r="7" fill="#8056EE"/>
														</svg> <h5 className='mb-1 ml-2'>สาขาสันทราย</h5>
													</div>

													<div className='mb-2'>
														{
															Data?.branch[2].spend_customer.map( (item, key) => {
																return (
																	<div className='d-flex border-top border-1 pt-1'>
																		<div>{ key + 1 }</div>
																		<div className='mr-auto ml-3 dash-main-text'><b>{ item.total }</b></div>
																		<div className='mr-0 ml-auto'>{ item.name }</div>
																	</div>
																)
															})
														}
													</div>

												</div>
											</Col>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '10px' }} className='dash-content dash-shadow'>
													<div className='d-flex mb-2'>
														<svg width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
															<circle cx="7" cy="7" r="7" fill="#5E36C7"/>
														</svg> <h5 className='mb-1 ml-2'>สาขา Relyne</h5>
													</div>

													<div className='mb-2'>
														{
															Data?.branch[3].spend_customer.map( (item, key) => {
																return (
																	<div className='d-flex border-top border-1 pt-1'>
																		<div>{ key + 1 }</div>
																		<div className='mr-auto ml-3 dash-main-text'><b>{ item.total }</b></div>
																		<div className='mr-0 ml-auto'>{ item.name }</div>
																	</div>
																)
															})
														}
													</div>

												</div>
											</Col>
										</Row>
										<h5 className='mt-4 pl-1'>Top Spends By Product</h5>
										<Row style={{ paddingLeft: '10px',marginTop: '15px' }}>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '10px' }} className='dash-content dash-shadow'>
													<div className='d-flex mb-2'>
														<svg width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
															<circle cx="7" cy="7" r="7" fill="#C4C4C4"/>
														</svg> <h5 className='mb-1 ml-2'>สาขาสวนดอก</h5>
													</div>

													<div className='mb-2'>
														{
															Data?.branch[0].spend_product.map( (item, key) => {
																return (
																	<div className='d-flex border-top border-1 pt-1'>
																		<div>{ key + 1 }</div>
																		<div className='mr-auto ml-3 dash-main-text'><b>{ item.total }</b></div>
																		<div className='mr-0 ml-auto text-right'>{ item.product }</div>
																	</div>
																)
															})
														}
													</div>

												</div>
											</Col>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '10px' }} className='dash-content dash-shadow'>
													<div className='d-flex mb-2'>
														<svg width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
															<circle cx="7" cy="7" r="7" fill="#ECD1FF"/>
														</svg> <h5 className='mb-1 ml-2'>สาขาอาเขต</h5>
													</div>

													<div className='mb-2'>
														{
															Data?.branch[1].spend_product.map( (item, key) => {
																return (
																	<div className='d-flex border-top border-1 pt-1'>
																		<div>{ key + 1 }</div>
																		<div className='mr-auto ml-3 dash-main-text'><b>{ item.total }</b></div>
																		<div className='mr-0 ml-auto text-right'>{ item.product }</div>
																	</div>
																)
															})
														}
													</div>

												</div>
											</Col>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '10px' }} className='dash-content dash-shadow'>
													<div className='d-flex mb-2'>
														<svg width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
															<circle cx="7" cy="7" r="7" fill="#8056EE"/>
														</svg> <h5 className='mb-1 ml-2'>สาขาสันทราย</h5>
													</div>

													<div className='mb-2'>
														{
															Data?.branch[2].spend_product.map( (item, key) => {
																return (
																	<div className='d-flex border-top border-1 pt-1'>
																		<div>{ key + 1 }</div>
																		<div className='mr-auto ml-3 dash-main-text'><b>{ item.total }</b></div>
																		<div className='mr-0 ml-auto text-right'>{ item.product }</div>
																	</div>
																)
															})
														}
													</div>

												</div>
											</Col>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '10px' }} className='dash-content dash-shadow'>
													<div className='d-flex mb-2'>
														<svg width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
															<circle cx="7" cy="7" r="7" fill="#5E36C7"/>
														</svg> <h5 className='mb-1 ml-2'>สาขา Relyne</h5>
													</div>

													<div className='mb-2'>
														{
															Data?.branch[3].spend_product.map( (item, key) => {
																return (
																	<div className='d-flex border-top border-1 pt-1'>
																		<div>{ key + 1 }</div>
																		<div className='mr-auto ml-3 dash-main-text'><b>{ item.total }</b></div>
																		<div className='mr-0 ml-auto text-right'>{ item.product }</div>
																	</div>
																)
															})
														}
													</div>

												</div>
											</Col>
										</Row>

										<h5 className='mt-4 pl-1'>Voucher</h5>
										<Row style={{ paddingLeft: '10px',marginTop: '15px' }}>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '10px' }} className='dash-content dash-shadow'>
													<div className='d-flex mb-2'>
														<h5 className='mb-1 ml-2'>รวมทั้งหมด</h5>
													</div>

													<div className='mb-2'>
														{
															Data?.voucher.map( (item, key) => {
																return (
																	<div className='d-flex border-top border-1 pt-1'>
																		<div className='mr-auto ml-3 dash-main-text'><b>{ item.name }</b></div>
																		<div className='mr-0 ml-auto text-right'>{ item.used }/{ item.total }</div>
																	</div>
																)
															})
														}
													</div>

												</div>
											</Col>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '10px' }} className='dash-content dash-shadow'>
													<div className='d-flex mb-2'>
														<svg width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
															<circle cx="7" cy="7" r="7" fill="#C4C4C4"/>
														</svg> <h5 className='mb-1 ml-2'>สาขาสวนดอก</h5>
													</div>

													<div className='mb-2'>
														{
															Data?.voucher.map( (item, key) => {
																return (
																	<div className='d-flex border-top border-1 pt-1'>
																		<div className='mr-auto ml-3 dash-main-text'><b>{ item.name }</b></div>
																		<div className='mr-0 ml-auto text-right'>{ item['สวนดอก'] }/{ item.total }</div>
																	</div>
																)
															})
														}
													</div>

												</div>
											</Col>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '10px' }} className='dash-content dash-shadow'>
													<div className='d-flex mb-2'>
														<svg width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
															<circle cx="7" cy="7" r="7" fill="#ECD1FF"/>
														</svg> <h5 className='mb-1 ml-2'>สาขาอาเขต</h5>
													</div>

													<div className='mb-2'>
														{
															Data?.voucher.map( (item, key) => {
																return (
																	<div className='d-flex border-top border-1 pt-1'>
																		<div className='mr-auto ml-3 dash-main-text'><b>{ item.name }</b></div>
																		<div className='mr-0 ml-auto text-right'>{ item['อาเขต'] }/{ item.total }</div>
																	</div>
																)
															})
														}
													</div>

												</div>
											</Col>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '10px' }} className='dash-content dash-shadow'>
													<div className='d-flex mb-2'>
														<svg width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
															<circle cx="7" cy="7" r="7" fill="#8056EE"/>
														</svg> <h5 className='mb-1 ml-2'>สาขาสันทราย</h5>
													</div>

													<div className='mb-2'>
														{
															Data?.voucher.map( (item, key) => {
																return (
																	<div className='d-flex border-top border-1 pt-1'>
																		<div className='mr-auto ml-3 dash-main-text'><b>{ item.name }</b></div>
																		<div className='mr-0 ml-auto text-right'>{ item['สันทราย'] }/{ item.total }</div>
																	</div>
																)
															})
														}
													</div>

												</div>
											</Col>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '10px' }} className='dash-content dash-shadow'>
													<div className='d-flex mb-2'>
														<svg width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
															<circle cx="7" cy="7" r="7" fill="#5E36C7"/>
														</svg> <h5 className='mb-1 ml-2'>สาขา Relyne</h5>
													</div>

													<div className='mb-2'>
														{
															Data?.voucher.map( (item, key) => {
																return (
																	<div className='d-flex border-top border-1 pt-1'>
																		<div className='mr-auto ml-3 dash-main-text'><b>{ item.name }</b></div>
																		<div className='mr-0 ml-auto text-right'>{ item['Relyne'] }/{ item.total }</div>
																	</div>
																)
															})
														}
													</div>

												</div>
											</Col>
										</Row>

									</div>
									{/* //*End Performance Session */}

									{/* //* Popular Service Session */}
									<div class="dash-content text-left pb-4 mt-4">
										<Row>
											<Col xs={12} md={6}><h2 className='dash-main-text'>Popular Service</h2></Col>
											<Col xs={12} md={6}></Col>
										</Row>
										<Row style={{ paddingLeft: '15px',marginTop: '15px' }}>
											<Col xs={12} className='dash-content dash-shadow'>
												<Row style={{paddingLeft: '15px',paddingRight: '15px'}}>
													<Col xs={12} md={6} className='pt-2 pb-2'>
														<div className='d-flex'>
															<div>
																<svg width="60" height="60" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
																	<circle cx="45" cy="45" r="45" fill="#6A3093"/>
																	<path d="M63.8889 39.1667H71.4444C73.4483 39.1667 75.3701 39.9744 76.787 41.4122C78.204 42.85 79 44.8 79 46.8333V54.5C79 55.5167 78.602 56.4917 77.8935 57.2106C77.185 57.9295 76.2241 58.3333 75.2222 58.3333H69.5556M63.8889 39.1667H39.3333M63.8889 39.1667L54.758 23.7222C54.0867 22.5869 53.1371 21.6474 52.0017 20.9951C50.8664 20.3428 49.5839 20 48.2791 20H39.3333M69.5556 58.3333C69.5556 60.3667 68.7595 62.3167 67.3426 63.7545C65.9256 65.1923 64.0039 66 62 66C59.9961 66 58.0744 65.1923 56.6574 63.7545C55.2405 62.3167 54.4444 60.3667 54.4444 58.3333M69.5556 58.3333C69.5556 56.3 68.7595 54.35 67.3426 52.9122C65.9256 51.4744 64.0039 50.6667 62 50.6667C59.9961 50.6667 58.0744 51.4744 56.6574 52.9122C55.2405 54.35 54.4444 56.3 54.4444 58.3333M39.3333 39.1667V20M39.3333 39.1667H18.5556M39.3333 20H28.5289C26.7816 19.9993 25.088 20.6131 23.7366 21.737C22.3851 22.8609 21.4594 24.4254 21.1169 26.164L18.5556 39.1667M18.5556 39.1667C16.5517 39.1667 14.6299 39.9744 13.213 41.4122C11.796 42.85 11 44.8 11 46.8333V54.5C11 55.5167 11.398 56.4917 12.1065 57.2106C12.815 57.9295 13.7758 58.3333 14.7778 58.3333H20.4444M20.4444 58.3333C20.4444 60.3667 21.2405 62.3167 22.6574 63.7545C24.0744 65.1923 25.9961 66 28 66C30.0039 66 31.9256 65.1923 33.3426 63.7545C34.7595 62.3167 35.5556 60.3667 35.5556 58.3333M20.4444 58.3333C20.4444 56.3 21.2405 54.35 22.6574 52.9122C24.0744 51.4744 25.9961 50.6667 28 50.6667C30.0039 50.6667 31.9256 51.4744 33.3426 52.9122C34.7595 54.35 35.5556 56.3 35.5556 58.3333M35.5556 58.3333H54.4444" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
																</svg>
															</div>
															<div className='mr-0 ml-2 ml-md-4'>
																<h3 className='mb-0'>รถ</h3>
																<span>จำนวน</span>
															</div>
															<div className='ml-2 ml-md-5 d-flex pt-3'>
																<h1 className='mb-0 dash-main-text'>{ Data?.all_car }</h1>
																<div className='pt-3 ml-2 dash-main-text'>คัน</div>
															</div>
														</div>
													</Col>
													<Col xs={12} md={6} style={{ borderLeft: '3px solid #c4c4c4'}} className='pt-2 pb-2'>
														<div className='d-flex'>
															<div>
																<svg width="60" height="60" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
																	<circle cx="45" cy="45" r="45" fill="#6A3093"/>
																	<path d="M49.25 20.2857C49.25 19.1491 48.8022 18.059 48.0052 17.2553C47.2082 16.4515 46.1272 16 45 16C43.8728 16 42.7918 16.4515 41.9948 17.2553C41.1978 18.059 40.75 19.1491 40.75 20.2857C40.75 21.4224 41.1978 22.5124 41.9948 23.3162C42.7918 24.1199 43.8728 24.5714 45 24.5714C46.1272 24.5714 47.2082 24.1199 48.0052 23.3162C48.8022 22.5124 49.25 21.4224 49.25 20.2857ZM26.3 34.8571C27.4272 34.8571 28.5082 34.4056 29.3052 33.6019C30.1022 32.7982 30.55 31.7081 30.55 30.5714C30.55 29.4348 30.1022 28.3447 29.3052 27.541C28.5082 26.7372 27.4272 26.2857 26.3 26.2857C25.1728 26.2857 24.0918 26.7372 23.2948 27.541C22.4978 28.3447 22.05 29.4348 22.05 30.5714C22.05 31.7081 22.4978 32.7982 23.2948 33.6019C24.0918 34.4056 25.1728 34.8571 26.3 34.8571ZM14.4 57.1429C12.5194 57.1429 11 58.675 11 60.5714C11 62.4679 12.5194 64 14.4 64H75.6C77.4806 64 79 62.4679 79 60.5714C79 58.675 77.4806 57.1429 75.6 57.1429H14.4ZM63.7 34.8571C64.8272 34.8571 65.9082 34.4056 66.7052 33.6019C67.5022 32.7982 67.95 31.7081 67.95 30.5714C67.95 29.4348 67.5022 28.3447 66.7052 27.541C65.9082 26.7372 64.8272 26.2857 63.7 26.2857C62.5728 26.2857 61.4918 26.7372 60.6948 27.541C59.8978 28.3447 59.45 29.4348 59.45 30.5714C59.45 31.7081 59.8978 32.7982 60.6948 33.6019C61.4918 34.4056 62.5728 34.8571 63.7 34.8571ZM32.25 46.1607L35.1081 51.5071C35.7775 52.7607 37.3181 53.2214 38.5613 52.5571C39.8044 51.8929 40.2613 50.3286 39.6025 49.075L35.7456 41.8429C35.9263 41.6607 36.0856 41.4571 36.2025 41.2214L39.05 35.875V41.7143C39.05 43.6107 40.5694 45.1429 42.45 45.1429H47.55C49.4306 45.1429 50.95 43.6107 50.95 41.7143V35.875L53.8081 41.2214C53.9356 41.4571 54.0844 41.6607 54.265 41.8429L50.4081 49.075C49.7388 50.3286 50.2063 51.8821 51.4494 52.5571C52.6925 53.2321 54.2331 52.7607 54.9025 51.5071L57.75 46.1607V50.2857C57.75 52.1821 59.2694 53.7143 61.15 53.7143H66.25C68.1306 53.7143 69.65 52.1821 69.65 50.2857V46.1607L72.5081 51.5071C73.1775 52.7607 74.7181 53.2214 75.9613 52.5571C77.2044 51.8929 77.6613 50.3286 77.0025 49.075L72.9756 41.5429C71.35 38.4893 68.1838 36.5821 64.7412 36.5821H62.6588C60.9269 36.5821 59.2694 37.0643 57.835 37.9321L54.265 31.2571C52.6394 28.2036 49.4731 26.2964 46.0306 26.2964H43.9588C40.5163 26.2964 37.3606 28.2036 35.7244 31.2571L32.1544 37.9321C30.72 37.0643 29.0625 36.5821 27.3306 36.5821H25.2587C21.8162 36.5821 18.6606 38.4893 17.0244 41.5429L13.0081 49.0643C12.3388 50.3179 12.8063 51.8714 14.0494 52.5464C15.2925 53.2214 16.8331 52.75 17.5025 51.4964L20.35 46.1607V50.2857C20.35 52.1821 21.8694 53.7143 23.75 53.7143H28.85C30.7306 53.7143 32.25 52.1821 32.25 50.2857V46.1607Z" fill="white"/>
																</svg>
															</div>
															<div className='mr-0 ml-2 ml-md-4'>
																<h3 className='mb-0'>ลูกค้า</h3>
																<span>จำนวน</span>
															</div>
															<div className='ml-2 ml-md-5 d-flex pt-3'>
																<h1 className='mb-0 dash-main-text'>{ Data?.all_customer }</h1>
																<div className='pt-3 ml-2 dash-main-text'>คน</div>
															</div>
														</div>
													</Col>
												</Row>
											</Col>
										</Row>
										<Row style={{ paddingLeft: '10px',marginTop: '15px' }}>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '10px' }} className='dash-content dash-shadow'>
													<h5 className='mb-3'>
														<svg width="16" height="16" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '10px' }}>
															<circle cx="17.5" cy="17.5" r="17.5" fill="#C4C4C4"/>
														</svg>
														สาขาสวนดอก
													</h5>
													<div className='d-flex mb-2'>
														<div className='mr-auto ml-auto'><h3 className='dash-main-text'>{ Data?.branch[0].total_car } คัน</h3></div>
														<div className='mr-4 ml-auto pt-1' style={{ opacity: '0.4',fontSize: '18px' }}>({ Number((Data?.branch[0].total_car / Data?.all_car_int) * 100).toFixed(2) }%)</div>
													</div>
													<div className='d-flex mb-2'>
														<div className='mr-auto ml-auto'><h3 className='dash-main-text'>{ Data?.branch[0].total_customer } คน</h3></div>
														<div className='mr-4 ml-auto pt-1' style={{ opacity: '0.4',fontSize: '18px' }}>({ Number((Data?.branch[0].total_customer / Data?.all_car_int) * 100).toFixed(2) }%)</div>
													</div>
													<div className="text-center">ใช้บริการซ้ำ จำนวน   { Data?.branch[0].return_customer }   คน</div>
												</div>
											</Col>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '10px' }} className='dash-content dash-shadow'>
													<h5 className='mb-3'>
														<svg width="16" height="16" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '10px' }}>
															<circle cx="17.5" cy="17.5" r="17.5" fill="#D8BDEC"/>
														</svg>
														สาขาอาเขต
													</h5>
													<div className='d-flex mb-2'>
														<div className='mr-auto ml-auto'><h3 className='dash-main-text'>{ Data?.branch[1].total_car } คัน</h3></div>
														<div className='mr-4 ml-auto pt-1' style={{ opacity: '0.4',fontSize: '18px' }}>({ Number((Data?.branch[1].total_car / Data?.all_car_int) * 100).toFixed(2) }%)</div>
													</div>
													<div className='d-flex mb-2'>
														<div className='mr-auto ml-auto'><h3 className='dash-main-text'>{ Data?.branch[1].total_customer } คน</h3></div>
														<div className='mr-4 ml-auto pt-1' style={{ opacity: '0.4',fontSize: '18px' }}>({ Number((Data?.branch[1].total_customer / Data?.all_car_int) * 100).toFixed(2) }%)</div>
													</div>
													<div className="text-center">ใช้บริการซ้ำ จำนวน   { Data?.branch[1].return_customer }   คน</div>
												</div>
											</Col>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '10px' }} className='dash-content dash-shadow'>
													<h5 className='mb-3'>
														<svg width="16" height="16" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '10px' }}>
															<circle cx="17.5" cy="17.5" r="17.5" fill="#8056EE"/>
														</svg>
														สาขาสันทราย
													</h5>
													<div className='d-flex mb-2'>
														<div className='mr-auto ml-auto'><h3 className='dash-main-text'>{ Data?.branch[2].total_car } คัน</h3></div>
														<div className='mr-4 ml-auto pt-1' style={{ opacity: '0.4',fontSize: '18px' }}>({ Number((Data?.branch[2].total_car / Data?.all_car_int) * 100).toFixed(2) }%)</div>
													</div>
													<div className='d-flex mb-2'>
														<div className='mr-auto ml-auto'><h3 className='dash-main-text'>{ Data?.branch[2].total_customer } คน</h3></div>
														<div className='mr-4 ml-auto pt-1' style={{ opacity: '0.4',fontSize: '18px' }}>({ Number((Data?.branch[2].total_customer / Data?.all_car_int) * 100).toFixed(2) }%)</div>
													</div>
													<div className="text-center">ใช้บริการซ้ำ จำนวน   { Data?.branch[2].return_customer }   คน</div>
												</div>
											</Col>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '10px' }} className='dash-content dash-shadow'>
													<h5 className='mb-3'>
														<svg width="16" height="16" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '10px' }}>
															<circle cx="17.5" cy="17.5" r="17.5" fill="#5E36C7"/>
														</svg>
														สาขา Relyne
													</h5>
													<div className='d-flex mb-2'>
														<div className='mr-auto ml-auto'><h3 className='dash-main-text'>{ Data?.branch[3].total_car } คัน</h3></div>
														<div className='mr-4 ml-auto pt-1' style={{ opacity: '0.4',fontSize: '18px' }}>({ Number((Data?.branch[3].total_car / Data?.all_car_int) * 100).toFixed(2) }%)</div>
													</div>
													<div className='d-flex mb-2'>
														<div className='mr-auto ml-auto'><h3 className='dash-main-text'>{ Data?.branch[3].total_customer } คน</h3></div>
														<div className='mr-4 ml-auto pt-1' style={{ opacity: '0.4',fontSize: '18px' }}>({ Number((Data?.branch[3].total_customer / Data?.all_car_int) * 100).toFixed(2) }%)</div>
													</div>
													<div className="text-center">ใช้บริการซ้ำ จำนวน   { Data?.branch[3].return_customer }   คน</div>
												</div>
											</Col>
										</Row>
										<Row style={{ paddingLeft: '10px',marginTop: '15px' }}>
											<Col xs={12} md={6} style={{ padding: '7px' }}>
												<div style={{ padding: '15px' }} className='dash-content dash-shadow'>
													<div><h5>Brand จำนวนยี่ห้อที่มีเยอะที่สุด</h5></div>
													{
														!isLoading ?
															<ReactApexChart options={stateBrand.options} series={stateBrand.series} type="bar" height={250} />
														: ''
													}
												</div>
											</Col>
											<Col xs={12} md={6} style={{ padding: '7px' }}>
												<div style={{ padding: '15px' }} className='dash-content dash-shadow'>
													<div><h5>Series จำนวนรุ่นที่มีเยอะที่สุด</h5></div>
													{
														!isLoading ? 
															<ReactApexChart options={stateSeries.options} series={stateSeries.series} type="bar" height={250} />
														: ''
													}
												</div>
											</Col>
										</Row>
										<h5 className='mt-4 pl-1'>Brand Loyalty</h5>
										<div className='dash-content dash-shadow mt-3'>
											{
												Data?.customer_list.map( (item, key) => {
													return (
														<>
															<div className='d-none d-md-flex mb-2'>
																<div style={{ width: '4%' }}>{ key + 1 }</div>
																<div style={{ width: '30%' }}>คุณ { item.name }   </div>
																<div className='text-center' style={{ width: '18%' }}>{ item.diff_date }</div>
																<div className='text-center dash-main-text' style={{ width: '24%' }}>{ item.total_job } ครั้ง</div>
																<div className='text-center dash-main-text' style={{ width: '24%' }}>{ item.total } บาท</div>
															</div>
															<div className='d-md-none mb-3 d-block'>
																<div className='d-flex mb-1'>
																	<div style={{ width: '4%' }}>{ key + 1 }</div>
																	<div style={{ width: '70%' }}>คุณ { item.name }   </div>
																	<div className='text-right dash-main-text' style={{ width: '26%' }}>{ item.total_job } ครั้ง</div>
																</div>
																<div className='d-flex mb-2'>
																	<div style={{ width: '4%' }}></div>
																	<div className='text-left' style={{ width: '30%' }}>{ item.diff_date }</div>
																	<div className='text-right dash-main-text' style={{ width: '66%' }}>{ item.total } บาท</div>
																</div>
															</div>
														</>
													)
												})
											}
										</div>
									</div>
									{/* //* End Popular Service Session */}

									{/* //* What New Session */}
									<div class="dash-content text-left pb-4 mt-4">
										<Row>
											<Col xs={12} md={6}><h2 className='dash-main-text'>What’s New</h2></Col>
											<Col xs={12} md={6}></Col>
										</Row>
										<Row style={{ paddingLeft: '10px',marginTop: '10px' }}>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '15px' }} className='dash-content dash-shadow'>
													<div className='d-flex mt-1 mb-1'>
														<div><h4 className='mb-0'><b>New car</b></h4></div>
														<div className='mr-0 ml-auto'>
															<h4 className='mb-0 dash-main-text'>{ Data?.new[0].new_car } คัน</h4>
														</div>
													</div>
												</div>
											</Col>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '15px' }} className='dash-content dash-shadow'>
													<div className='d-flex mt-1 mb-1'>
														<div><h4 className='mb-0'><b>New customer</b></h4></div>
														<div className='mr-0 ml-auto'>
															<h4 className='mb-0 dash-main-text'>{ Data?.new[0].new_customer} คน</h4>
														</div>
													</div>
												</div>
											</Col>
											<Col xs={12} sm={6} md={4} style={{ padding: '7px' }}>
												<div style={{ padding: '15px' }} className='dash-content dash-shadow'>
													<div className='d-flex mt-1 mb-1'>
														<div><h4 className='mb-0'><b>Return</b></h4></div>
														<div className='mr-0 ml-auto'>
															<h4 className='mb-0 dash-main-text'>{ Data?.new[0].return_job } คัน</h4>
														</div>
													</div>
												</div>
											</Col>
										</Row>
									</div>
									{/* //* End What New Session */}

							{/* //TODO: End Content */}

						</div>
						</div>
					</div>
				</div>
		</Container>
		<Footer />
		</>
  );
}